import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { initTelemetry } from "@/lib/telemetrySDK";

// ── PostHog telemetry bridge — opt-in via REACT_APP_POSTHOG_KEY ──────────
//
// When the key is unset, the bridge no-ops and events fired via the
// `track()` shim continue to dispatch into the void (the pre-PostHog
// behaviour). When the key is set, every `xpert:telemetry` CustomEvent
// is forwarded to posthog.capture(). See src/lib/telemetrySDK.js for
// the full env contract + privacy posture.
//
// Bootstrapped BEFORE the React render so the bridge listener is
// registered before the first useEffect fires its first event.
initTelemetry();

// ── Sentry — opt-in via REACT_APP_SENTRY_DSN ─────────────────────────────
//
// When the DSN env var is empty/unset, Sentry is not initialised and the
// app runs exactly as before. When it's set, errors + 10% performance
// traces + replays-on-error are sent.
//
// Privacy: maskAllText + blockAllMedia in replays so we never capture
// user-typed content or images. sendDefaultPii=false at the top level.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || "dev",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,            // 10% of routes profiled
    replaysSessionSampleRate: 0.0,    // no random session replays
    replaysOnErrorSampleRate: 0.1,    // 10% of errors get a replay attached
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
